import { resolveInlineStatus } from '@communio/inline-status';

/** Inline page feedback. Async outcomes that outlive the page stay on the notification bell. */

type Props = {
  loading?: boolean;
  error?: string | null;
  empty?: string | null;
};

export function InlineStatus({ loading, error, empty }: Props) {
  const view = resolveInlineStatus({ loading, error, empty });
  if (view.kind === 'loading') {
    return (
      <p className="text-muted" role="status">
        {view.message}
      </p>
    );
  }
  if (view.kind === 'error') {
    return (
      <p className="form-error" role="alert">
        {view.message}
      </p>
    );
  }
  if (view.kind === 'empty') {
    return <p className="text-muted">{view.message}</p>;
  }
  return null;
}
